var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title is-1 glitch",attrs:{"data-text":"The Factory Bloc"}},[_vm._v("The Factory Bloc")])])}]

export { render, staticRenderFns }